// ── RegiNA email-check gate ─────────────────────────────────────────────────
(function () {
    'use strict';

    // Set window.regiEmailCheckDebug = true in devtools for verbose logging.
    function dbg() {
        if (window.regiEmailCheckDebug) console.log.apply(console, ['[regi-email-check]'].concat(Array.prototype.slice.call(arguments)));
    }

    var form = document.querySelector('[data-regi-email-check]');
    if (!form) {
        console.log('[regi-email-check] no form found – script idle');
        return;
    }

    var REGI_FORM_STATE      = 'regiForm';
    var USERNAME_PLACEHOLDER = '{username}';

    var formId      = form.getAttribute('data-regi-email-check');
    var serviceUrl  = form.getAttribute('data-regi-email-check-service-url');
    var redirectUrl = form.getAttribute('data-regi-email-check-redirect-url');
    var noRedir     = form.getAttribute('data-regi-email-check-no-login-redirect') === 'true';

    var embedEl    = document.querySelector('[data-regi-embed="' + formId + '"]');
    var usernameEl = form.querySelector('[name="username2"]');
    var errorEl    = form.querySelector('[data-regi-email-check-error]');

    var loginData = null, loginDataExtra = null;
    try {
        var el1 = document.getElementById('login-data');
        var el2 = document.getElementById('voucher-wizard-data');
        var el3 = document.getElementById('login-data-additional');
        var raw1 = el1 && el1.textContent.trim();
        var raw2 = el2 && el2.textContent.trim();
        loginData      = raw1 ? JSON.parse(raw1) : (raw2 ? JSON.parse(raw2) : null);
        loginDataExtra = el3 && el3.textContent.trim() || null;
    } catch (e) {
        console.warn('[regi-email-check] login-data parse error:', e);
    }

    var params         = new URLSearchParams(window.location.search);
    var loginAttempted = !!params.get('loginAttempt');
    var loginIncorrect = !!(window.DIMEDIS && window.DIMEDIS.session && window.DIMEDIS.session.loginIncorrect);
    var isLoginMode    = false;
    var isLoading      = false;

    console.log('[regi-email-check] init', {
        formId:        formId,
        serviceUrl:    serviceUrl,
        noRedir:       noRedir,
        loginAttempted: loginAttempted,
        loginIncorrect: loginIncorrect,
        embedEl:       !!embedEl,
        loginData:     !!loginData
    });

    if (loginIncorrect || loginAttempted) {
        dbg('restoring login mode (loginIncorrect=' + loginIncorrect + ', loginAttempted=' + loginAttempted + ')');
        setLoginMode(true);
        var loginErrEl = document.getElementById('regi-email-check-login-incorrect-message');
        if (loginErrEl) loginErrEl.classList.remove('visuallyhidden');
    }

    if (window.history && window.history.state) {
        history.replaceState({}, 'Email Check');
    }

    // ── popstate (browser back) ─────────────────────────────────────────────
    window.addEventListener('popstate', function (e) {
        var state = e.state;
        if (state && state.id === REGI_FORM_STATE) {
            showRegi(state.userName || '', false);
        } else {
            form.setAttribute('data-regi-email-check-visible', 'true');
            if (embedEl) embedEl.setAttribute('data-regi-embed-visible', 'false');
        }
    });

    // ── form submit ─────────────────────────────────────────────────────────
    form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email      = usernameEl.value.replace(/\s+/g, '');
        var loginErrEl = document.getElementById('regi-email-check-login-incorrect-message');
        if (loginErrEl) loginErrEl.classList.add('visuallyhidden');

        if (isLoginMode) {
            var pwdEl = form.querySelector('[name="passwd"]');
            if (pwdEl && pwdEl.value) {
                dbg('submit: login mode → submitLogin');
                submitLogin(email, pwdEl.value);
            } else {
                console.warn('[regi-email-check] no password entered');
            }
            return;
        }

        if (isLoading) return;
        if (!isValidEmail(email)) {
            dbg('submit: invalid email →', email);
            errorEl.setAttribute('data-regi-email-check-error', 'true');
            return;
        }
        dbg('submit: valid email, calling checkEmail');
        checkEmail(email);
    });

    // ── email field events ──────────────────────────────────────────────────
    usernameEl.addEventListener('focus', function () {
        if (loginAttempted) return;
        errorEl.setAttribute('data-regi-email-check-error', 'false');
        var loginErrEl = document.getElementById('regi-email-check-login-incorrect-message');
        if (loginErrEl) loginErrEl.classList.add('visuallyhidden');
    });

    usernameEl.addEventListener('input', function () {
        if (loginAttempted) return;
        setLoginMode(false);
    });

    // ── helpers ─────────────────────────────────────────────────────────────
    function isValidEmail(val) {
        return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z|\-|_]{2,}$/.test(val);
    }

    function checkEmail(email) {
        isLoading = true;
        var url = serviceUrl.split(USERNAME_PLACEHOLDER).join(encodeURIComponent(email));
        dbg('checkEmail: GET', url);
        fetch(url, { headers: { 'Accept': 'application/json' } })
            .then(function (r) {
                if (!r.ok) throw new Error('HTTP ' + r.status);
                return r.json();
            })
            .then(function (data) {
                isLoading = false;
                dbg('checkEmail: response', data);
                if (data.account_exists) {
                    if (noRedir) {
                        dbg('account exists → login mode (noRedir)');
                        setLoginMode(true);
                    } else {
                        dbg('account exists → redirect');
                        window.location.href = redirectUrl.split(USERNAME_PLACEHOLDER).join(encodeURIComponent(email));
                    }
                } else {
                    dbg('no account → showRegi');
                    showRegi(email, true);
                }
            })
            .catch(function (err) {
                isLoading = false;
                console.warn('[regi-email-check] request failed:', err);
            });
    }

    function showRegi(email, pushState) {
        dbg('showRegi email=' + email + ' pushState=' + pushState);
        if (pushState && window.history && window.history.pushState) {
            history.pushState({ id: REGI_FORM_STATE, userName: email }, 'Regi Form');
        }
        document.dispatchEvent(new CustomEvent('dim-regi:fill-form', { detail: { email: email } }));
        form.setAttribute('data-regi-email-check-visible', 'false');
        if (embedEl) embedEl.setAttribute('data-regi-embed-visible', 'true');
    }

    function setLoginMode(active) {
        dbg('setLoginMode', active);
        isLoginMode = active;
        toggle(document.getElementById('password-field'),              active);
        toggle(document.getElementById('password-field-description-text'), active);
        toggle(document.getElementById('password-forgotten'),          active);
        toggle(document.getElementById('regi-email-check-submit-button'), !active);
        toggle(document.getElementById('regi-email-check-login-button'),   active);
    }

    function toggle(el, visible) {
        if (!el) return;
        el.classList.toggle('visuallyhidden', !visible);
    }

    function submitLogin(email, password) {
        if (!loginData) return;
        var f = document.createElement('form');
        f.action = window.location.href.replace('#/', '') + '&loginAttempt=true';
        f.method = 'POST';
        [
            ['oid',          loginData.oid],
            ['ticket',       loginData.ticket],
            ['lang',         loginData.lang],
            ['username2',    email],
            ['passwd',       password],
            ['voucher_code', loginData.voucherCode || ''],
            ['sri',          loginData.sri || ''],
            ['event',        'login'],
            ['voucher_event','show_reg_form']
        ].forEach(function (pair) {
            var inp   = document.createElement('input');
            inp.type  = 'hidden';
            inp.name  = pair[0];
            inp.value = pair[1];
            f.appendChild(inp);
        });
        if (loginDataExtra) {
            var inp   = document.createElement('input');
            inp.type  = 'hidden';
            inp.name  = 'login_data_additional';
            inp.value = loginDataExtra;
            f.appendChild(inp);
        }
        document.body.appendChild(f);
        f.submit();
    }
})();
